import React from 'react'

type Filters={
    cities?: string[];
  adBoardTypes?: string[];
  specifications?: string[];
  rangePrices?: [number, number];
  isOnSale?: boolean;
  guestsAndBags?: {
    passengers: number;
    bags: number;
  };
}

const FiltersContext = React.createContext<{
  filters: Filters;
  setFilters: (filters: Filters) => void;
    }>({
      filters: {},
    } as any);

export const useFilters = () => React.useContext(FiltersContext);

export default function FilterProvider({
  children
}:{
    children:React.ReactNode
}) {

  const [filters, setFilters] = React.useState({});
  
  return (
    <FiltersContext.Provider value={{ filters, setFilters }}>
      {children}
    </FiltersContext.Provider>
  );
}
